<template>
  <div id="match_player_detail_outer" class="vue_body_min_height" style="padding-bottom: 50px;">
    <img v-if="currentBanner != null && currentBanner != undefined" :src="currentBanner.url" style="width: 100%;">

    <div v-if="user != null" id="player_content" class="container">
      <div class="user-desc">
        <img class="user-icon" :src="userImg">
        <div class="user-name">{{user.name}}</div>
        <div class="user-detail">
          <div class="item">
            <div>号码</div>
            <div>{{user.jersey_no}}</div>
          </div>
          <div class="item">
            <div>位置</div>
            <div>{{positionText}}</div>
          </div>
          <div class="item">
            <div>年龄</div>
            <div>{{user.age}}</div>
          </div>
          <div class="item">
            <div>身高(cm)</div>
            <div>{{user.height}}</div>
          </div>

          <div class="item">
            <div>体重(kg)</div>
            <div>{{user.weight}}</div>
          </div>

          <div class="item">
            <div>球队</div>
            <div>{{user.team.name}}</div>
          </div>

        </div>
      </div>
      <div class="basket-data" v-if="gameData != null">
        <div style="font-size: 1.2rem;font-weight: bold;color: #333;">基础数据</div>
        <div class="detail">
          <div class="item">
            <div>{{gameData.matches}}</div>
            <div>场次</div>
          </div>

          <div class="item">
            <div>{{gameData.field_score}}</div>
            <div>得分</div>
          </div>

          <div class="item">
            <div>{{gameData.rebound_num}}</div>
            <div>篮板</div>
          </div>

          <div class="item">
            <div>{{gameData.assist_num}}</div>
            <div>助攻</div>
          </div>

          <div class="item">
            <div>{{gameData.field_percentage}}</div>
            <div>总命中率</div>
          </div>

          <div class="item">
            <div>{{gameData.two_point_percentage}}</div>
            <div>两分命中率</div>
          </div>

          <div class="item">
            <div>{{gameData.three_point_percentage}}</div>
            <div>三分命中率</div>
          </div>

        </div>
      </div>

      <div class="basket-data" v-if="gameData != null">
        <div style="font-size: 1.2rem;font-weight: bold;color: #333;">深度数据</div>
        <div class="detail">
          <div class="item">
            <div>{{gameData.ave_shoot_angle}}</div>
            <div>平均出手角度</div>
          </div>

          <div class="item">
            <div>{{gameData.ave_shoot_speed}}</div>
            <div>平均出手球速</div>
          </div>

        </div>
      </div>

      <div class="user-videos" v-if="videoList != null && videoList.length > 0">
        <div style="font-size: 1.2rem;font-weight: bold;color: #333;">个人集锦</div>

        <video-item-card
          v-for="(item, index) in videoList" :key="'person-video' + index"
          v-on:play="playVideo"
          v-bind:item="item" ></video-item-card>

        <video-play-dialog v-if="showVideoDialog"
                           v-bind:video-url="'https://obs.zheshi.tech/'+ currentItem.video_path"
                           v-on:close="videoDialogClosed"></video-play-dialog>
      </div>
    </div>

  </div>
</template>

<script>
  import TestImg from '../../assets/shl_game_play_default.png'
  import GameHttpManager from '../../js/outer-games-http-define';
  import VideoPlayDialog from "../../components/common/VideoPlayDialog";
  import VideoItemCard from "./VideoItemCard";
export default {
  name: "MatchPlayerDetailPage",
  components: {
    VideoItemCard,
    VideoPlayDialog
  },
  data() {
    return {
      user: null,
      userImg: TestImg,
      showVideoDialog: false,
      gameData: null,
      gameList: null,
      totalListData: null,
      videoFullList: null,
      videoList: null,
      // videoList: [
      //   {
      //     game_id: 2,
      //     video_path: "https://img.shslqxh.com/4399422b-b86f-4966-928a-15ba2de6557a.mp4",
      //     cover_path: "https://img.shslqxh.com/9422e44db0a64f9e9045705c20ee1628.png",
      //   },
      //
      //   {
      //     game_id: 2,
      //     video_path: "https://img.shslqxh.com/4399422b-b86f-4966-928a-15ba2de6557a.mp4",
      //     cover_path: "https://img.shslqxh.com/9422e44db0a64f9e9045705c20ee1628.png",
      //   },
      //
      //   {
      //     game_id: 2,
      //     video_path: "https://img.shslqxh.com/4399422b-b86f-4966-928a-15ba2de6557a.mp4",
      //     cover_path: "https://img.shslqxh.com/9422e44db0a64f9e9045705c20ee1628.png",
      //   },
      //
      //   {
      //     game_id: 2,
      //     video_path: "https://img.shslqxh.com/4399422b-b86f-4966-928a-15ba2de6557a.mp4",
      //     cover_path: "https://img.shslqxh.com/9422e44db0a64f9e9045705c20ee1628.png",
      //   },
      // ]
    }
  },
  computed: {

    positionText() {
      let position = this.user.position;

      switch (position) {
        case 1:
          return 'PG';
        case 2:
          return 'SG';
        case 3:
          return 'SF';
        case 4:
          return 'PF';
        case 5:
          return 'C';
        default:
          return '暂无';
      }

    },

    userId() {
      return this.$route.params.id;
    },

    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'matches';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },
  },
  mounted() {
    // console.log('---1');
    this.loadData();
    this.loadBasketballData();
    this.loadVideoListData();
  },

  methods: {

    playVideo(item) {
      // console.log(item)
      this.currentItem = item;
      this.showVideoDialog = true;
    },
    videoDialogClosed() {
      this.showVideoDialog = false;
    },

    loadData() {
      let _this = this;
      GameHttpManager.getPlayerDetail(this.userId,function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.user = data.data;
          // console.log(_this.user);
          return;
        }
      }, function (data) {

      })
    },
    loadBasketballData() {
      let _this = this;
      GameHttpManager.getPlayerGameListData(function (data) {
        // console.log(data);
        let status = data.status;
        if (status == 'success') {
          _this.totalListData = data.data;
          _this.dealWithGameListData();
          return;
        }
      }, function (data) {

      })
    },
    dealWithGameListData() {
      let listData = this.totalListData;

      let temp = [];
      let userId = this.userId;
      for (let i = 0; i < listData.length; i++) {
        let item = listData[i];
        if (item.player_id == userId) {
          temp.push(item);
        }
      }
      this.totalListData = null;
      if (temp.length > 0) {
        this.gameList = temp;


        let field_score = 0;
        let rebound_num = 0;
        let assist_num = 0;
        let field_percentage = 0;
        let two_point_percentage = 0;
        let three_point_percentage = 0;
        let ave_shoot_angle = 0;
        let ave_shoot_speed = 0;

        for(let i = 0; i < temp.length; i++) {
          let item = temp[i];

          field_score += item.field_score;
          rebound_num += item.rebound_num;
          assist_num += item.assist_num;
          field_percentage += item.field_percentage;
          two_point_percentage += item.two_point_percentage;
          three_point_percentage += item.three_point_percentage;

          ave_shoot_angle += item.ave_shoot_angle;
          ave_shoot_speed += item.ave_shoot_speed;
        }

        let matches = temp.length;
        console.log(field_score);
        field_percentage = this.toPercent(field_percentage / matches);
        two_point_percentage = this.toPercent(two_point_percentage / matches);
        three_point_percentage = this.toPercent(three_point_percentage / matches);
        ave_shoot_speed = ave_shoot_speed / matches;
        ave_shoot_speed = new Number(ave_shoot_speed).toFixed(1);

        ave_shoot_angle = ave_shoot_angle / matches;
        ave_shoot_angle = new Number(ave_shoot_angle).toFixed(1);

        let gameData = {
          matches: temp.length,
          field_score,
          rebound_num,
          assist_num,
          field_percentage,
          two_point_percentage,
          three_point_percentage,
          ave_shoot_speed,
          ave_shoot_angle
        };
        this.gameData = gameData;
      }
    },
    loadVideoListData() {
      let _this = this;
      GameHttpManager.getVideosListData(function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.videoFullList = data.data;
          _this.dealWithVideoListLoadSuccess();
        }
      }, function (data) {

      });
    },
    dealWithVideoListLoadSuccess() {
      let videoFullList = this.videoFullList;
      if (videoFullList == null) {
        return;
      }

      let userId = this.userId;
      let temp = [];
      for (let i = 0; i < videoFullList.length; i++) {
        let videoItem = videoFullList[i];
        if (userId == videoItem.player_id) {
          temp.push(videoItem);
        }
      }

      this.videoList = temp;

    }
  }
}
</script>

<style scoped>
  #match_player_detail_outer #player_content {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    padding: 20px 15px;
    margin-top: 30px;
    padding-bottom: 40px;
  }

  #player_content > div {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #player_content .user-desc {
    margin-top: 15px;
  }

  #player_content .user-icon {
    width: 80px;
    height: auto;
  }

  #player_content .user-name {
    margin-top: 15px;
    font-size: 1.5rem;
  }

  #player_content .user-desc .user-detail {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    margin-top: 5px;
    width: 90%;
    max-width: 500px;
    min-width: 250px;
  }

  #player_content .user-desc .user-detail .item {
    text-align: center;
    padding: 0 15px;
    margin-top: 15px;
  }

  #player_content .user-desc .user-detail .item > div {
    letter-spacing: 2px;
  }

  #player_content .user-desc .user-detail .item div:last-child {
    margin-top: 10px;
    font-weight: bold;
    font-size: 1.2rem;
  }

  #player_content .basket-data {
    margin-top: 50px;
  }

  #player_content .basket-data .detail {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    margin-top: 5px;
    width: 90%;
    max-width: 800px;
    min-width: 250px;
  }

  #player_content .basket-data .detail .item {
    text-align: center;
    padding: 0 15px;
    margin-top: 15px;
  }

  #player_content .basket-data .detail .item > div {
    letter-spacing: 2px;
  }

  #player_content .basket-data .detail .item > div:last-child {
    margin-top: 10px;
  }

  #player_content .basket-data .detail .item > div:first-child {
    font-weight: bold;
    font-size: 1.2rem;
  }

  #player_content .user-videos {
    margin-top: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/MatchPlayerDetailPage.vue